import { GeneratedReportsModule } from '@/shared';

export default GeneratedReportsModule;
